import React from 'react'
import "./Footer.css"
import Logofooter from "./faviconfooter.png"
import { Button } from '@material-ui/core'
import { Link } from "react-router-dom"


function Footer(props) {
    return (
        <div className="app_footer">
        <div className="app_footer_left">
            <Link to="/about" Style="text-decoration:none"> <Button size="small">ABOUT US</Button> </Link>
            <Link to="/contact" Style="text-decoration:none"> <Button size="small">CONTACT</Button> </Link>
            <Link to="/privacy" Style="text-decoration:none"> <Button size="small">PRIVACY</Button> </Link>
            <Link to="/terms" Style="text-decoration:none"> <Button size="small">TERMS</Button> </Link>
        </div>
        
        <div className="app_footer_right">
            <img className="app_footerImage" src={Logofooter} alt="Lmypet" />
            <p> @LoveMyPet 2020</p>
        </div>
        
      </div>
    )
}


export default Footer

